module.exports = __webpack_public_path__ + "static/media/exclamation.d09d69fc.svg";